module.exports = __webpack_public_path__ + "71612e90c0bb1cb6003b584e1eab8831.svg";